import React, { useEffect } from 'react';
import { FadeUp } from './ui/FadeUp';
import { Article } from '../data/articles';
import { ArrowLeftIcon } from 'lucide-react';
interface ArticlePageProps {
  article: Article;
  onNavigate: (view: any) => void;
}
export function ArticlePage({
  article,
  onNavigate
}: ArticlePageProps) {
  // Ensure we scroll to top when article mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [article.slug]);
  return <div className="pt-32 pb-28 bg-white min-h-screen" data-id="element-18">
      <div className="max-w-3xl mx-auto px-8" data-id="element-19">
        <FadeUp data-id="element-20">
          <button onClick={() => onNavigate('insights')} className="flex items-center text-purple-500 hover:text-purple-700 font-medium mb-12 transition-colors group" data-id="element-21">
            <ArrowLeftIcon className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-22" />
            Back to Insights
          </button>
        </FadeUp>

        <FadeUp delay={0.1} data-id="element-23">
          <header className="mb-12" data-id="element-24">
            <div className="flex flex-wrap items-center gap-3 mb-6" data-id="element-25">
              <span className="text-xs font-medium text-purple-500 bg-purple-50 px-2.5 py-1 rounded-full" data-id="element-26">
                {article.category}
              </span>
              <span className="text-sm text-[#9CA3AF] font-medium" data-id="element-27">
                {article.date}
              </span>
              <span className="text-[#9CA3AF]" data-id="element-28">•</span>
              <span className="text-sm text-[#9CA3AF] font-medium" data-id="element-29">
                SparkHR Operations
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-8" data-id="element-30">
              {article.title}
            </h1>
            <div className="h-px w-full bg-[#eee]" data-id="element-31"></div>
          </header>
        </FadeUp>

        <FadeUp delay={0.2} data-id="element-32">
          <div className="space-y-8 text-lg text-gray-700 leading-relaxed" data-id="element-33">
            {article.content.map((paragraph, index) => <p key={index} data-id="element-34">{paragraph}</p>)}
          </div>
        </FadeUp>

        <FadeUp delay={0.3} className="mt-16 pt-12 border-t border-[#eee]" data-id="element-35">
          <div className="bg-[#faf6ff] rounded-xl p-8 border border-[#eee] text-center" data-id="element-36">
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-37">
              Ready to structure your People Operations?
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-38">
              SparkHR provides the embedded support growing teams need.
            </p>
            <a href="https://calendly.com/krystina-joinsparkhr/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-white bg-gradient-primary rounded-full hover:shadow-md hover:opacity-90 transition-all" data-id="element-39">
              Book an Intro Call
            </a>
          </div>
        </FadeUp>
      </div>
    </div>;
}